import { render, staticRenderFns } from "./sectors.vue?vue&type=template&id=72419886&scoped=true&"
import script from "./sectors.ts?vue&type=script&lang=ts&"
export * from "./sectors.ts?vue&type=script&lang=ts&"
import style0 from "./sectors.scss?vue&type=style&index=0&id=72419886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72419886",
  null
  
)

export default component.exports